import React from 'react'
import { twMerge } from 'tailwind-merge'

import { AvatarIcon } from '../../icons'
import { Box } from '../box'
import { Icon } from '../icon'
import { Image } from '../image'

export type UserPhotoProps = {
    base64Img?: string
    size?: number
    className?: string
}

export const UserPhoto: React.FC<UserPhotoProps> = ({ base64Img, size = 32, className }) => {
    if (!base64Img) {
        return (
            <Icon
                as={AvatarIcon}
                size={size}
                className={twMerge('text-content-default', className)}
            />
        )
    }

    return (
        <Box
            className={twMerge('shrink-0 overflow-hidden rounded-full', className)}
            style={{ width: size, height: size }}
        >
            <Image source={{ uri: base64Img }} alt='User photo' className='h-full w-full' />
        </Box>
    )
}
